import { memo } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

interface NodeExpandToggleProps {
  nodeId: string;
  isExpanded: boolean;
  onToggleExpand: (id: string) => void;
}

function NodeExpandToggleComponent({ nodeId, isExpanded, onToggleExpand }: NodeExpandToggleProps) {
  return (
    <button
      type="button"
      className="mt-1.5 flex w-full items-center justify-center gap-1 rounded py-0.5 text-xs text-[hsl(var(--muted-foreground))] hover:bg-[hsl(var(--muted))] transition-colors"
      onClick={(e) => {
        e.stopPropagation();
        onToggleExpand(nodeId);
      }}
    >
      {isExpanded ? (
        <>
          <ChevronDown className="h-3 w-3" /> Collapse
        </>
      ) : (
        <>
          <ChevronRight className="h-3 w-3" /> Expand
        </>
      )}
    </button>
  );
}

export const NodeExpandToggle = memo(NodeExpandToggleComponent);
